import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AnnouncementState = {
  isRead: boolean;
};
const initialState: AnnouncementState = {
  isRead: false,
};

export const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    onChangeRead: (state, action: PayloadAction<boolean>) => {
      state.isRead = action.payload;
    },
  },
});

export const { onChangeRead } = announcementSlice.actions;

export default announcementSlice;
